import { CheckCircle2, Circle, Loader2, XCircle } from "lucide-react";

const ICON = {
  offen: <Circle className="w-4 h-4 text-slate-300" />,
  laeuft: <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />,
  ok: <CheckCircle2 className="w-4 h-4 text-emerald-600" />,
  fehler: <XCircle className="w-4 h-4 text-rose-600" />,
};

// Fortschritt eines Versandmitteilungs-Jobs: Rechnung anlegen → Briefpapier → PDF → Mail einreihen
export const JobProgress = ({ job, testId = "job-progress" }) => (
  <ol className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={testId}>
    {job.steps.map((st) => (
      <li key={st.key} className="flex items-center gap-1.5" data-testid={`${testId}-${st.key}`} data-status={st.status}>
        {ICON[st.status] || ICON.offen}<span className={st.status === "laeuft" ? "font-medium text-slate-900" : "text-slate-600"}>{st.label}</span>
      </li>
    ))}
  </ol>
);
